import { calculateOfferDuration } from '@/constants/hooks';
import { faCalendarDays, FontAwesomeIcon } from '@/constants/icons';
import React from 'react'

interface Props {
    endDate: string | null;
    className?: string;
}
const OfferDuration = ({ endDate, className }: Props) => {
    const durationText = calculateOfferDuration(endDate);
    const isExpiring = endDate !== null && endDate !== undefined;

    return (
        <div className={`flex items-center gap-1.5 ${className ?? ''}`}>
            {isExpiring ? (
                /* ── Expiring / Limited Time Style ── */
                <div className="flex items-center gap-1.5 px-3 py-1.5 rounded-full bg-[#FEE2E2] border border-[#DC2626]/20 animate-pulse">
                    <FontAwesomeIcon
                        icon={faCalendarDays}
                        className="w-3 h-3 text-[#DC2626]"
                    />
                    <span className="text-[10px] font-black uppercase tracking-wider text-[#DC2626]">
                        {durationText}
                    </span>
                </div>
            ) : (
                /* ── Always Active / Verified Style ── */
                <div className="flex items-center gap-1.5 px-3 py-1.5 rounded-full bg-[#DCFCE7] border border-[#15803D]/20">
                    <FontAwesomeIcon
                        icon={faCalendarDays}
                        className="w-3 h-3 text-[#15803D]"
                    />
                    <span className="text-[10px] font-black uppercase tracking-wider text-[#15803D]">
                        {durationText}
                    </span>
                </div>
            )}
        </div>
    );
}

export default OfferDuration
